const UserRoleEnum = Object.freeze({
    ADMINISTRATOR: 1,
    INVESTOR: 2,
    ORIGINATOR: 3,
    STRUCTURER: 4,
  });
  
  export default UserRoleEnum;